const developConfigurations = {
 identityPoolId: "us-east-1:037e1815-e3b0-491a-b92e-968314ec4fcd",
        region: "us-east-1",
        identityPoolRegion: "us-east-1",
        userPoolId: "us-east-1_63gHKNZSa",
        userPoolWebClientId: "3bdsf49asocte170p7ahkrjcnm",
}

const productionConfigurations = {
        identityPoolId: "us-east-1:037e1815-e3b0-491a-b92e-968314ec4fcd",
        region: "us-east-1",
        identityPoolRegion: "us-east-1",
        userPoolId: "us-east-1_63gHKNZSa",
        userPoolWebClientId: "3bdsf49asocte170p7ahkrjcnm",
}

export const amplifyConfigurations = process.env.REACT_APP_STAGE === 'develop' ? developConfigurations : productionConfigurations;